import React from 'react'
import { useTranslation } from 'react-i18next'
import { getEventLabel } from '@fs/zion-sls'
import { Row, H2, IconButton } from '@fs/zion-ui'
import { ContentEdit } from '@fs/zion-icon'
import FieldWrapper from '../../ui/FieldWrapper'

const InfoSectionHeader = ({ element, onEditClick, slsTypes, indented, disabled = false }) => {
  const [t] = useTranslation()
  let label = ''
  if (element.elementType === 'EVENT') label = getEventLabel(element, slsTypes)
  else label = element.label
  const dataTestId =
    element?.elementType === 'NAME'
      ? 'edit-essential-information-icon'
      : `edit-${
          element?.eventType || element?.nameType || element?.fieldType || element?.elementType || 'unknown'
        }-icon`

  return (
    <Row wrap={false}>
      <FieldWrapper indent="0">
        {!indented && <H2 size="H5">{label}</H2>}
        {indented && <H2 size="H6">{label}</H2>}
      </FieldWrapper>
      <IconButton
        disabled={disabled}
        Icon={ContentEdit}
        onClick={(e) => {
          onEditClick(e)
        }}
        size="md"
        data-testid={dataTestId}
        aria-label={t('view-index.edit.button.aria-label', `Edit {elementType}`, { elementType: element.label })}
      />
    </Row>
  )
}

export default InfoSectionHeader
